import { adminHttpClient } from '../../../commons/adminHttpClient'
import { WizardStatus } from '../../../../domain/wizard/wizard'
import AllowanceType from '../../../../domain/benefit/allowanceType'

export interface BenefitDesignStateValues {
  benefitStartDate: string
  sameClassForAll: boolean | null
  allowanceType: AllowanceType | null
  designClasses: ProductClassValues[]
  benefitEndDate: string
  wizardStatus: WizardStatus
  isBenefitEditable: boolean
  restrictedExpenseCategories: any[]
}

export interface ProductClassValues {
  id: string
  name: string
  status: WizardStatus
  hasEmployeesAssigned: boolean
}

const getGroupHraBenefitDesignState = (planPeriod?: string): Promise<BenefitDesignStateValues> => {
  return adminHttpClient.get(`/AdminDashboard/BenefitDetails/BenefitDesignWizardState/${planPeriod}`)
}

export default getGroupHraBenefitDesignState
